import React from 'react';

// Material UI
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

// Component
import { IntlMsg } from '../_core/IntlMsg/intl-msg.component';
import { getMessages } from './report.messages';
import { useCompanySportTerminology } from '../../lib/stores/company.store';
import { REPORT_REFRESH_MINUTES, useReportsLastChecked } from '../../lib/stores/report.store';

export const ReportFreshnessNotice: React.FC = () => {
  const termLookup = useCompanySportTerminology();
  const lastChecked = useReportsLastChecked();
  const messages = getMessages(termLookup);

  return (
    <Box>
      <Typography>
        <IntlMsg
          {...messages.lblLastChecked}
          values={{ minutes: REPORT_REFRESH_MINUTES, time: lastChecked.format('h:mm A') }}
        />
      </Typography>
      <Typography variant="caption" color="textSecondary" display="block">
        <IntlMsg {...messages.lblProcessingDelay} />
      </Typography>
    </Box>
  );
};
